import React, { useState ,useEffect} from 'react';
import { Box, Grid, Paper } from '@mui/material';
import axios from 'axios';
import CustomTextField from '../customComponent/CustomTextField';
import {Ticker} from '../../utils/Ticker'
const CurrencyConverter = ({ setPrice, setDynamicPrice, dynamicPrice, fiat }) => {
  const [piAmount, setPiAmount] = useState('');
  const [fiatAmount, setFiatAmount] = useState(dynamicPrice?.fiat);
  const [ticker, setTicker] = useState(null);
  const [rate, setRate] = useState([]);
  const [piPrice, setPiPrice] = useState(0);
  const [isValuesSet, setIsValuesSet] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchTicker = async () => {
      const newTicker = new Ticker(process.env.REACT_APP_COINTICKER_API_KEY);
      await newTicker.fetchRates(fiat);
      console.log(newTicker)
      setTicker(newTicker);
      //console.log(newTicker.rate);
      setRate(newTicker.rate);
      setPiPrice(newTicker.piPrice);
      
    };

    fetchTicker();
  }, [fiat]);

  const convertCurrency = async (value, fromPi = true) => {
    if (!value) return;
    
   /*  setLoading(true);
    setError(''); */
    
    try {
      const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/products/ticker/dynamicprice`, {
        params: {
          key: 'c55683aaf175c34805747c9c48c6bce012803ab093a5064171814184b0632903',
          from: fromPi ? 'PI' : fiat, //determine which currency to convert from : true 
          to: fromPi ? fiat : 'PI',
          amount: value
        }
      });
         
        //set values for product 
        setPrice(response.data.Pi.toFixed(8));
        setDynamicPrice((prev) => ({
          ...prev,
          Pi: response.data.Pi.toFixed(8),
         // fiat: response.data.amount.toFixed(8)
        }));

       setFiatAmount(response.data.amount.toFixed(2));
       setPiAmount(response.data.Pi.toFixed(8));
    
    } catch (err) {
      setError('Conversion failed. Please try again.');
      console.error('Conversion error:', err);
    } finally {
      setLoading(false);
    }
  };

  const handlePiChange = (e) => {
    const value = e.target.value;
    setPiAmount(value);
    if (value && rate && piPrice) {
       convert('PI', fiat, value, rate, piPrice).then(res=>{
        setFiatAmount(parseFloat(res.amount.toFixed(2)));
        console.log(res);
        // setPiAmount(res.Pi.toFixed(8));
          setDynamicPrice((prev) => ({
          ...prev,
          Pi: parseFloat(res.Pi.toFixed(8)),
          fiat: parseFloat(res.amount.toFixed(2)),

      }));
      });
     }
   };

    const handleFiatChange = (e) => {
    const value = e.target.value;
    setFiatAmount(value);
    if (value && rate && piPrice) {
      convert(fiat, 'PI', value, rate, piPrice).then(res=>{
        console.log(res);
       // setFiatAmount(res.amount.toFixed(2));
        setPiAmount(parseFloat(res.Pi.toFixed(8)));
          setDynamicPrice((prev) => ({
          ...prev,
          Pi: parseFloat(res.Pi.toFixed(8)),
          fiat: parseFloat(res.amount.toFixed(2))
      }));
      });
    }
  };

  const convert = async (from, to, amount, rate, piPrice) => {
    const productAmount = amount ? parseFloat(amount) : 0;
    console.log(piPrice);
    if (from === 'PI') {
      rate = ticker.rate === to;
    } else {
      rate = ticker.rate === from;
    }
    /*   if (!rate) return null;
    if (rate.value <= 0) return null;
    if (piPrice <= 0) return null; */
    console.log(ticker.rate.value);
    const convertedPiValue =  ticker.convertCurrentPiValueinProvidedFiat(ticker.rate.value, piPrice); // Convert current Pi value equivalent to provided fiat
    console.log(convertedPiValue);
    const convertFiattoPi =  ticker.convertFiattoPi(productAmount, convertedPiValue);

    const convertPitoFiat   =  ticker.convertPitoFiat(productAmount, convertedPiValue);
      console.log(convertedPiValue)

    if (from === 'PI') {
      return  {
        from,
        to,
        Pi: productAmount,
        amount: convertPitoFiat,
      };

    } else if (to === 'PI') {
      return {
        from,
        to,
        amount: productAmount,
        Pi: convertFiattoPi,
      };
    } else {
      return null;
    }

   
  }
   useEffect(()=>{
    if(!isValuesSet){
       setPiAmount(dynamicPrice?.Pi);
      setFiatAmount(dynamicPrice?.fiat);
    }
    return ()=>{
      setIsValuesSet(true);
    }
  }, [dynamicPrice, isValuesSet, setPiAmount, setFiatAmount]);
  return (
    <Paper elevation={0} sx={{ p: 0 }}>
      {ticker ? <Box  noValidate autoComplete="off">

        <Grid container spacing={2} direction="row">
          <Grid item xs={6}>
            <CustomTextField
              fullWidth
              label="Pi Amount"
              value={piAmount}
              onChange={handlePiChange}
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
             /*  disabled={loading} 
              helperText="Enter amount in Pi"*/
            />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField
              fullWidth
              label={`${fiat} Amount`}
              value={fiatAmount}
              onChange={handleFiatChange}
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              /* disabled={loading} 
              helperText={`Enter amount in ${fiat}`}*/
            />
          </Grid>

          {/* error && (
            <Grid item xs={12}>
              <Typography color="error" variant="body2">
                {error}
              </Typography>
            </Grid>
          ) */}
        </Grid>
      </Box>:""}
    </Paper>
  );
};

export default CurrencyConverter;